import { db } from "./index.js";

export const ENTRY_STATUS = {
  PENDING: "pending",
  SYNCING: "syncing",
  FAILED: "failed",
};

function isActionable(entry) {
  return (
    entry.status === ENTRY_STATUS.PENDING ||
    entry.status === ENTRY_STATUS.FAILED ||
    entry.status === ENTRY_STATUS.SYNCING
  );
}

export async function enqueueHarvestEntry(farmId, formData, display) {
  return await db.harvestEntryQueue.add({
    farm_id: farmId,
    form_data: formData,
    display,
    status: ENTRY_STATUS.PENDING,
    error_message: null,
    created_at: new Date().toISOString(),
  });
}

export async function getPendingEntries(farmId) {
  return await db.harvestEntryQueue
    .where("farm_id")
    .equals(farmId)
    .and(isActionable)
    .toArray();
}

export async function getPendingCount(farmId) {
  return await db.harvestEntryQueue
    .where("farm_id")
    .equals(farmId)
    .and(isActionable)
    .count();
}

export async function markEntryStatus(id, status, errorMessage = null) {
  return await db.harvestEntryQueue.update(id, {
    status,
    error_message: errorMessage,
  });
}

export async function deleteEntry(id) {
  return await db.harvestEntryQueue.delete(id);
}
